import LoyaltyTierLabel from 'components/Common/Labels/LoyaltyTierLabel'
import TextButton from 'LuxKit/Button/TextButton'
import BodyText from 'LuxKit/Typography/BodyText'
import type { ReactElement } from 'react'
import { useCallback, useContext, useMemo } from 'react'
import { useIntl } from 'react-intl'
import LandingPageLoyaltyBenefitTile from './LandingPageLoyaltyBenefitTile'
import ModalContext from 'contexts/ModalContext'
import LandingPageLoyaltyAirportTransferBenefitsModal from './LandingPageLoyaltyAirportTransferBenefitsModal'

interface Props {
  tier: App.LoyaltyTier
  benefitLabel: ReactElement
}

function LandingPageLoyaltyAirportTransfersTile(props: Props) {
  const { tier, benefitLabel } = props
  const showModal = useContext(ModalContext)
  const intl = useIntl()
  const image = useMemo<App.Image>(() => ({
    id: '0qt5tc9nvf1qd3f0t5fe',
    title: intl.formatMessage({
      id: '2HRtf-FUlQHl0uAxrGqo',
      defaultMessage: 'Free airport chauffeur service',
      description: 'Alternative text fallback for the airport chauffeur service loyalty benefit image',
    }),
  }), [intl])

  const handleDetailsClick = useCallback(() => {
    showModal(<LandingPageLoyaltyAirportTransferBenefitsModal
      image={image}
    />)
  }, [image, showModal])

  return <LandingPageLoyaltyBenefitTile
    heading={intl.formatMessage({
      id: 'goasM7VIjFQCeUINc7qq',
      defaultMessage: 'Free airport chauffeur service',
      description: 'Heading for loyalty airport chauffeur transfer benefit tile',
    })}
    labels={<LoyaltyTierLabel kind="primary" tier={tier}>{benefitLabel}</LoyaltyTierLabel>}
    image={image}
    actions={<TextButton kind="secondary" onClick={handleDetailsClick}>
      {intl.formatMessage({
        id: 'oTzhX6SBhrgFwFrBjaSN',
        defaultMessage: 'Details',
        description: 'Link to open airport transfer benefit details modal',
      })}
    </TextButton>}
  >
    <BodyText variant="medium">
      {intl.formatMessage({
        id: 'QgqDqaGPIybqBKCe2rj2',
        defaultMessage: 'Start and end your journey smoothly with free private airport transfers in select destinations. No stress, just seamless service.',
        description: 'Description of the free airport chauffeur transfer loyalty benefit',
      })}
    </BodyText>
  </LandingPageLoyaltyBenefitTile>
}

export default LandingPageLoyaltyAirportTransfersTile
